import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/logo.png';
import './MainHeader.css';

export default function MainHeader({ 
  title, 
  showBack = false, 
  backPath = '/home',
  rightButton = null,
  centerContent = null 
}) {
  const navigate = useNavigate();
  const { user, hasSession } = useAuth();
  const homePath = (user || hasSession) ? '/home' : '/';

  return (
    <header className="main-header">
      <div className="main-header-left">
        {showBack ? (
          <button onClick={() => navigate(backPath)} className="header-back-btn">
            ← Back
          </button>
        ) : (
          <img 
            src={logo} 
            alt="Hangrily" 
            className="header-logo-btn" 
            onClick={() => navigate(homePath)} 
            style={{ height: '28px', cursor: 'pointer' }} 
          />
        )}
      </div>
      
      <div className="main-header-center">
        {centerContent || <h1 className="main-header-title">{title}</h1>}
      </div>
      
      <div className="main-header-right">
        {rightButton}
      </div>
    </header>
  );
}
